import { SelectBox } from "devextreme-react/select-box";
import { RequiredRule, Validator } from "devextreme-react/validator";
import { useContext } from 'react';
import { useGetCompanyUsers } from '../../../../api/users';
import { useAuth } from '../../../../contexts/auth';
import { Field } from '../../../../layouts';
import { AR, OrderStatus, ScriptFileType } from '../../../../types/enums';
import { formatShortDate } from '../../../../utils/date-utils';
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';
import CallScriptComp from "../../call-script/component/CallScriptComp";
import DateBox from "devextreme-react/date-box";

export default function ScheduleCabinetDates() {

	const { order, modifyOrder, refetchOrder } = useContext(RetailOrderContext);

	const isOrderReadonly =
		order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	let dateRequired = order.details.activeARs.includes(AR.CfiToEnterScheduledInstallDate) ||
		order.details.activeARs.includes(AR.DealerToEnterCabinetPOReceivedDate) ||
		order.details.activeARs.includes(AR.InstallerToVerifyCabinetQuality);

	let dateReadOnly = !order.details.activeARs.includes(AR.CfiToEnterScheduledInstallDate) &&
		!order.details.activeARs.includes(AR.CfiToEnterActualInstallDate) &&
		!order.details.activeARs.includes(AR.DealerToEnterCabinetPOReceivedDate) &&
		!order.details.activeARs.includes(AR.InstallerToVerifyCabinetQuality);

	let installerReadOnly = dateReadOnly;

	const { user } = useAuth();
	const companyUsers = useGetCompanyUsers(user?.companyId!);

	return (
		<>
			<Field label={'Estimated Cabinet Delivery Date'}>
				{formatShortDate(order.details.estimatedCabinetDeliveryDate)}
			</Field>
			<Field label="Scheduled Install Start Date">
				<DateBox elementAttr={{ 'data-testid': 'dttb-scheduled-install-start-date' }}
					value={order.details.scheduledInstallStartDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledInstallStartDate: e.value })}
					readOnly={dateReadOnly || isOrderReadonly}
					className={dateRequired ? 'required' : ''}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Scheduled Install Start Date is required'} />}
					</Validator>
				</DateBox>
				{
					(order.details.activeARs.includes(AR.CfiToEnterScheduledInstallDate) || order.details.resolvedARs.includes(AR.CfiToEnterScheduledInstallDate)) &&
					<CallScriptComp
						fileType={ScriptFileType.CabinetInstallerScheduleDevilery}
						retailOrderID={order.details.retailOrderID}
						retailOrderNumber={order.details.roNumber}
						fileName={"Cabinets Installer Schedule Delivery and Installation"}
						fileAttachment={order.details.files}
						submitCallback={() => refetchOrder(RefetchScope.Files)}
					/>
				}
			</Field>
			<Field label="Scheduled Install Completion Date">
				<DateBox elementAttr={{ 'data-testid': 'dttb-scheduled-install-completion-date' }}
					value={order.details.scheduledInstallCompletionDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledInstallCompletionDate: e.value })}
					readOnly={dateReadOnly || isOrderReadonly}
					className={dateRequired ? 'required' : ''}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Scheduled Install Completion Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
			<Field label={'Installer'}>
				<SelectBox elementAttr={{ 'data-testid': 'dd-installer' }}
					value={order.details.installer}
					showClearButton={true}
					readOnly={installerReadOnly || isOrderReadonly}
					valueExpr={'userName'}
					displayExpr={'fullName'}
					onValueChanged={(e) => modifyOrder({ ...order.details, installer: e.value })}
					dataSource={companyUsers?.data.filter(x => x.groups?.includes('Installer') &&
						(!x.inactive || x.userName === order.details.installer))} />
			</Field>
		</>
	);
}
